import dayjs from 'dayjs';

import { dayjsCs } from '@/utils';

const DATE_FORMAT = 'D. M. YYYY';

export const SIMPLE_DATE_FORMAT = 'DD-MM-YYYY';
export const DEFAULT_FORMAT = 'DD. MM. YYYY';
export const DEFAULT_FORMAT_TIME = 'HH:mm';
export const DEFAULT_EMPTY_VALUE = '–';

const DEFAULT_TABLE_PAGE_SIZE = 50;

// This is max limit for api use it when you no need pagination and want to get all data
const DEFAULT_TABLE_PAGE_SIZE_HIGH = 0;

const DEFAULT_TABLE_OFFSET = 0;

export const YESTERDAY = dayjsCs().subtract(1, 'day').toDate();

export const TODAY = dayjs().toDate();

export const TOMORROW = dayjs().add(1, 'day').toDate();

export { DATE_FORMAT, DEFAULT_TABLE_OFFSET, DEFAULT_TABLE_PAGE_SIZE, DEFAULT_TABLE_PAGE_SIZE_HIGH };

export const ACCEPTED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
export const ACCEPTED_IMAGE_LOGO = ['image/png', 'image/jpeg', 'image/webp'];

export const ACCEPTED_SCRIPT_TYPES = ['text/plain'];

export const MAX_FILE_SIZE = 20000000;
export const MAX_ATTACHMENTS_SIZE = 1024 * 1024 * 15; // 15 MB

export const DEFAULT_DEBOUNCE_DELAY = 300;

export const MIN_SEARCH_LENGTH = 1;

export const refereeQualificationLevels: { [key: number]: string } = {
  0: 'Rozhodčí I. třída',
  1: 'Rozhodčí II. třída',
  2: 'Rozhodčí III. třída',
  3: 'Rozhodčí IV. třída',
};

export const trainersQualificationLevels: { [key: number]: string } = {
  0: 'Trenér I. třída',
  1: 'Trenér II. třída',
  2: 'Trenér III. třída',
  3: 'Trenér IV. třída',
  4: 'Diplomovaný trenér',
  5: 'Trenér mládeže',
  6: 'Trenér minivolejbalu',
};

export const NONE_VALUE = '-';

export const monthObject: { [key: number]: string } = {
  0: 'Leden',
  1: 'Únor',
  2: 'Březen',
  3: 'Duben',
  4: 'Květen',
  5: 'Červen',
  6: 'Červenec',
  7: 'Srpen',
  8: 'Září',
  9: 'Říjen',
  10: 'Listopad',
  11: 'Prosinec',
};

export const MAX_API_LIMIT = 200;

export const DEFAULT_DECIMAL_COUNT = 2;

export const FUTURE_SEASON = 'future';

// query-client
export const STALETIME_DEFAULT = 1000; // 1 sec
export const STALETIME_FILE = 600000; // 10 min

export const CVS_SUPPORTED_FILES = ['text/csv', 'application/csv', 'application/vnd.ms-excel', 'text/x-csv', 'application/x-csv'];

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export const STORAGE_FOLDER_PATH = 'browse-selected-path';
export const STORAGE_FOLDER_NAME_PATH = 'browse-selected-name-path';

export const OFFICE_SUPPORTED_SUMMARY_TYPES = [4, 12];

export const BREAKPOINTS = {
  'xs': 450,
  'sm': 640,
  'md': 768,
  'lg': 1024,
  'xl': 1280,
  '2xl': 1536,
} as const;

export type TBreakpoint = keyof typeof BREAKPOINTS;
